import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=2ff2211f&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=2ff2211f&prod&scoped=true&lang=css"
import style1 from "./InvoiceList.vue?vue&type=style&index=1&id=2ff2211f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff2211f",
  null
  
)

export default component.exports